import { Component, ElementRef, HostListener, Input, OnInit, ViewChild, AfterViewInit, Renderer2, OnDestroy, Output, EventEmitter } from '@angular/core';
import { IRequestModel } from '../my-orders-table/new-request.model';
import { ChatService } from 'src/app/services/chat.service';
import {
    NewChat, Chats, ThreadUsers, AllMessages, AddRemoveViewUsers,
    ChatUserInfo, Documents, SentDocumentsDetails, MessageMentions,
    Mentions,
    MessageSeen
} from 'src/app/models/chat';
import { retryWhen, tap, delay, concatMap, of, BehaviorSubject, take, Observable, fromEvent, Subscription, interval } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserList } from 'src/app/models/user-list';
import { BackendListModel } from 'src/app/models/common/list.model';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { TextFieldComponent } from '../../form-fields/text-field/text-field.component';
import { ChatEnum } from 'src/app/enums/chat';
import { QuillEditorComponent } from 'ngx-quill';
import "quill-mention";
import { RangeStatic } from 'quill';
import { DocumentApiService } from 'src/app/services/domain_code/document-api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
@Component({
    selector: 'logzy-communications',
    templateUrl: './communications.component.html',
    styleUrls: ['./communications.component.scss'],
})
export class CommunicationsComponent implements OnInit, AfterViewInit, OnDestroy {
    base_url = environment.baseApiUrl;

    @Input() requestDetails: IRequestModel | any;

    @Input()
    chatMessages: Chats[] = [];
    chatMessagesWithSeen: Chats[] = [];

    @Input() compact: boolean = false;
    @Input() chatBoxMax: boolean = false;
    @Input() mobileView: boolean = false;

    @Input()
    chatThread = new BehaviorSubject<any>(undefined);

    @Input()
    requestNumber: string;

    @Output() back: EventEmitter<any> = new EventEmitter();

    profile: boolean = false;
    profile1: boolean;
    addingUser: boolean = false;
    docLoading: boolean = false;
    disconSocket: boolean = false;
    reconnecting: boolean = false;
    message: string = '';
    replyingto: string = '';
    replyingName: string = '';
    replyingToTiming: string = '';
    chat_thread: string = '';
    current_user: string = '';
    newChat: NewChat;
    showEmojiPicker: boolean = false;
    showReplyBox: boolean = false;
    chatId: string = '';
    replyFlag: boolean = false;
    displayFile: boolean = false;
    objectKeys = Object.keys;
    threadUsers: ThreadUsers[] = [];
    allMessages: AllMessages;
    usersList: BackendListModel<UserList>;
    usersList_url = ApiRoutes.Company;
    selectedUser: ChatUserInfo = null;
    userActions: AddRemoveViewUsers;
    messageListPages: [];
    newChatFlag: boolean = false;
    mentionFlag: boolean = false;
    deletedText = '';
    choosed: string = 'chat';

    @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef;
    @ViewChild('chatterBox') chatterBox: TextFieldComponent;

    @ViewChild('toogleEmojiButton') emojiButton: ElementRef;
    @ViewChild('emojiPickerPopup') emojiPopup: ElementRef;

    @ViewChild('mentionsBox') mentionsBox: ElementRef;

    retryAttempts = 5;
    retryDelay = 5 * 60 * 1000;
    messageLength = 0;

    showMoreMessages: boolean = true;
    isCurrentUserOwner: boolean = false;
    isCurrentUserAdmin: boolean = false;
    loadMoreMessageFlag: boolean = false;
    deletedMessageFlag: boolean = false;
    reactMessageFlag: boolean = false;

    threadOwner: ThreadUsers = null;
    totalMessageCount: number = 0;

    uploadedFiles: Documents[] = [];
    selectedDocuments: string[] = [];

    allowedImageExt: string = ChatEnum.mime_accept_string_img;
    allowedFilesExt: string = ChatEnum.mime_accept_string_others;

    userFilterParam: string = '';
    isFileUploaded: boolean = false;

    chatDisconnected: boolean = false;
    excludedUsers: string = '';

    sentDocumentsDetails: SentDocumentsDetails[] = [];

    lastActivity: string = null;

    messageMentions: MessageMentions[] = [];

    showSuggestions: boolean = false;
    userSuggestions: ThreadUsers[] = [];

    insideChat: boolean = true;

    mentionFilteredData: ThreadUsers[] = [];
    mentionSearch: string = '';
    mentionedUsers: Mentions[] = [];
    seenUsersList: MessageSeen[] = [];
    userIsTypingList: string[] = [];
    userIsTyping: string = '';

    onlineEvent: Observable<Event>;
    offlineEvent: Observable<Event>;
    subscriptions: Subscription[] = [];
    connectionStatusMessage: string;
    connectionStatus: string;
    replyToMessage: string = '';
    uploadedDocumentsCount: number = 0;
    documentsNextPage: string = '';

    i18n: any = {
        search: 'Search',
        emojilist: 'List of emoji',
        notfound: 'No Emoji Found',
        clear: 'Clear',
        categories: {
            search: 'Search Results',
            recent: 'Frequently Used',
            people: 'Smileys & People',
            nature: 'Animals & Nature',
            foods: 'Food & Drink',
            activity: 'Activity',
            places: 'Travel & Places',
            objects: 'Objects',
            symbols: 'Symbols',
            flags: 'Flags',
            custom: 'Custom',
        },
        skintones: {
            1: 'Default Skin Tone',
            2: 'Light Skin Tone',
            3: 'Medium-Light Skin Tone',
            4: 'Medium Skin Tone',
            5: 'Medium-Dark Skin Tone',
            6: 'Dark Skin Tone',
        },
    };

    customEmojis = [
        {
            id: 'arconContainer',
            name: 'ArconContainer',
            shortName: 'arcon_container',
            shortNames: ['arcon_container'],
            keywords: ['arcon_container'],
            imageUrl: 'assets/images/favicon.png',
            colons: ':arconContainer',
            text: '',
            emoticons: [],
            custom: true,
            native: 'arcon',
        },
    ];

    modules = {};
    @ViewChild('editor', { static: false }) editor: QuillEditorComponent;

    constructor(public chatService: ChatService, private docService: DocumentApiService, private _snackBar: MatSnackBar,
        private dialog: MatDialog, private authService: AuthService
    ) {
        this.profile1 != this.profile;

        this.modules = {
            'toolbar': [
                ['bold', 'italic', 'underline', 'strike']
            ],
            mention: {
                table: true,
                mentionListClass: "ql-mention-list mat-elevation-z8",
                allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                showDenotationChar: false,
                spaceAfterInsert: false,
                onSelect: (item, insertItem) => {
                    const editor = this.editor.quillEditor;
                    insertItem(item);
                    // necessary because quill-mention triggers changes as 'api' instead of 'user'
                    editor.insertText(editor.getLength() - 1, "", "user");
                },
                source: (searchTerm, renderList) => {
                    const values = [];

                    this.threadUsers.map(user => {
                        values.push({
                            id: user.user.id,
                            value: user.user.first_name + ' ' + user.user.last_name
                        });
                    });

                    // if (this.threadUsers.length > 2)
                    //     values.push({
                    //         id: 0,
                    //         value: 'Everyone'
                    //     });

                    if (searchTerm.length === 0) {
                        renderList(values, searchTerm);
                    } else {
                        const matches = [];

                        values.forEach(entry => {
                            if (
                                entry.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
                            ) {
                                matches.push(entry);
                            }
                        });
                        renderList(matches, searchTerm);
                    }
                }
            },
        }
    }

    ngOnInit(): void {
        this.current_user = JSON.parse(
            localStorage.getItem('current_user')
        )?.id;

        if (this.requestDetails) {
            this.chat_thread = this.requestDetails?.chat_thread;
        } else {
            this.chatThread.subscribe(item => {
                if ('id' in item) {
                    this.chat_thread = item['id'];
                    this.threadUsers = item.thread_users;
                    this.getSentDocuments();
                }
            });
        }

        console.log('Chat Thread', this.chat_thread);
        this.getMessages();
        this.getSentDocuments();

        this.onlineEvent = fromEvent(window, 'online');
        this.offlineEvent = fromEvent(window, 'offline');

        this.subscriptions.push(this.onlineEvent.subscribe(e => {
            // this.connectionStatusMessage = 'Back to online';
            this.connectionStatus = 'Online';
            this.reconnectChat();
        }));

        this.subscriptions.push(this.offlineEvent.subscribe(e => {
            this.connectionStatusMessage = 'Connection lost! You are not connected to internet';
            this.connectionStatus = 'offline';
            this.disconSocket = true;
        }));
        this.chatBoxMax = this.compact;
        // console.log(this.choosed, this.compact, this.chatBoxMax, 'check this')
    }
    choosingTab(val) {
        this.choosed = val;
    }

    getMessages() {
        // this.reconnecting = true;
        this.chatMessages = [];
        this.chatService.wsSubject$
            .pipe(this.handleRetryError(2000))
            .subscribe({
                next: (msg) => {
                    // console.log(msg);
                    switch (msg.event) {
                        case "latest_chat_message_list": {
                            if (this.chatMessages.length == 0) {
                                this.chatMessages = msg.data.latest_messages;
                            } else {
                                if (this.newChatFlag == true) {
                                    this.newChatFlag = false;
                                } else {
                                    msg.data.latest_messages.map(item => {
                                        this.chatMessages = [...this.chatMessages, item];
                                    });
                                    this.messageLength = msg.data.message_count;

                                }
                            }
                            if (!this.loadMoreMessageFlag) {
                                this.threadUsers = msg.data.thread_users;
                                this.threadUsers = this.threadUsers.filter(user => user.thread == this.chat_thread);

                            }

                            this.totalMessageCount = msg.data.message_count;
                            this.userFilterParam = msg.data.user_filter_params != null ? '&' + msg.data.user_filter_params : '';
                            break;
                        }
                        case 'new_chat_message': {
                            this.chatMessages.unshift(msg.data);
                            this.newChatFlag = true;
                            if (msg.data.documents.length != 0)
                                this.getSentDocuments();
                            if (this.insideChat) {
                                setTimeout(() => {
                                    if (this.chatMessages.length != 0) {
                                        this.newChat = {
                                            type: 'message_seen',
                                            data: {
                                                message: this.chatMessages[this.chatMessages.length - 1].id
                                            }
                                        };
                                        // console.log(this.newChat);
                                        this.chatService.wsSubject$.next(this.newChat);
                                    }
                                }, 3000);
                            }
                            break;
                        }
                        case 'react_message': {
                            this.chatMessages.filter((item) => {
                                if (item.id == msg.data.id) {
                                    item.reactions = msg.data.reactions;
                                }
                            });
                            break;
                        }
                        case 'add_thread_user': {
                            let thread: string = '';
                            msg.data.map(user => {
                                thread = user.thread;
                            });
                            if (thread == this.chat_thread) {
                                this.threadUsers = msg.data;
                                this.chatService.noAccessToChat = false;
                            }
                            break;
                        }
                        case 'remove_thread_user': {
                            let thread: string = '';
                            msg.data.map(user => {
                                thread = user.thread;
                            });
                            if (thread == this.chat_thread)
                                this.threadUsers = msg.data;
                            break;
                        }
                        case 'edit_thread_user': {
                            let thread: string = '';
                            msg.data.map(user => {
                                thread = user.thread;
                            });
                            if (thread == this.chat_thread)
                                this.threadUsers = msg.data;
                            break;
                        }
                        case 'delete_chat_message': {
                            this.chatMessages = this.chatMessages.filter(item => {
                                return item.id !== msg.data.id;
                            });
                            break;
                        }
                        case 'unauthenticated': {
                            this.disconSocket = true;
                            this.reconnecting = false;
                            break;
                        }
                        case 'context_error': {
                            this.disconSocket = true;
                            this.chatService.noAccessToChat = true;
                            // alert(msg.data.thread);
                            // this.openWarning('User have no access to chat. Please contact Admin', '', 'I Understand');
                            break;
                        }
                        case 'edit_thread_user_invalid': {
                            this.chatService.noAccessToChat = true;
                            // alert(msg.data.user.message);
                            // this.openWarning('User have no access to chat. Please contact Admin', '', 'I Understand');
                            break;
                        }
                        case 'object_does_not_exist': {
                            this.chatService.noAccessToChat = true;
                            // alert(msg.data.id);
                            // this.openWarning('User have no access to chat. Please contact Admin', '', 'I Understand');
                            break;
                        }
                        case 'message_seen': {
                            this.chatMessages.map(message => {
                                if (message.sent_by != null) {
                                    if (message.thread == this.chat_thread) {
                                        if (this.current_user != msg.data.user.id) {
                                            if (message.message_seen.length > 0) {
                                                message.message_seen.map(user => {
                                                    let userId = [];
                                                    userId.push(user.user.id);
                                                    if (!userId.includes(msg.data.user.id))
                                                        message.message_seen.push(msg.data);
                                                });
                                            } else {
                                                message.message_seen.push(msg.data);
                                            }
                                        }
                                    }
                                }
                            });
                            break;
                        }
                        case 'new_chat_message_invalid': {
                            // alert(msg.data.thread[0].message);
                            this.openWarning(msg.data.thread[0].message, '', 'I Understand');
                            this.disconSocket = true;
                            break;
                        }
                        case 'message_typing_invalid': {
                            // alert(msg.data.thread[0].message);
                            this.openWarning(msg.data.thread[0].message, '', 'I Understand');
                            this.disconSocket = true;
                            break;
                        }
                        case 'message_typing': {
                            if (msg.data.thread == this.chat_thread) {
                                if (msg.data.is_typing) {
                                    if (this.current_user != msg.data.thread_user.user.id) {
                                        if (!this.userIsTypingList.includes(msg.data.thread_user.user.first_name + ' ' + msg.data.thread_user.user.last_name))
                                            this.userIsTypingList.push(msg.data.thread_user.user.first_name + ' ' + msg.data.thread_user.user.last_name);
                                    }
                                } else {
                                    if (this.current_user != msg.data.thread_user.user.id) {
                                        this.userIsTypingList.splice(this.userIsTypingList.indexOf(msg.data.thread_user.user.first_name + ' ' + msg.data.thread_user.user.last_name), 1);
                                    }
                                }
                            }
                            // console.log('this.userIsTypingList --->', this.userIsTypingList);
                            break;
                        }
                        case 'ping-invalid': {
                            this.disconSocket = true;
                            break;
                        }
                    }

                    if (this.userIsTypingList.length != 0) {
                        this.userIsTyping = '';
                        this.userIsTypingList.map(user => {
                            this.userIsTyping += user + ', ';
                        })
                    } else {
                        this.userIsTyping = '';
                    }

                    var txt = '';

                    if (this.userIsTypingList.length != 0) {
                        if (this.userIsTypingList.length == 1) {
                            txt = 'is typing ...';
                            this.userIsTyping = this.userIsTyping.replace(',', '');
                            this.userIsTyping += txt;
                        } else if (this.userIsTypingList.length == 2) {
                            txt = 'are typing ...';
                            this.userIsTyping = this.userIsTyping.replace(',', ' and');
                            this.userIsTyping += txt;
                            this.userIsTyping = this.userIsTyping.replace(',', '');
                        } else if (this.userIsTypingList.length > 2) {
                            txt = ' are typing ...';
                            this.userIsTyping = this.userIsTyping.substring(0, this.userIsTyping.length - 2);
                            var pos = this.userIsTyping.lastIndexOf(',');
                            this.userIsTyping = this.userIsTyping.substring(0, pos) + ' and' + this.userIsTyping.substring(pos + 1)
                            this.userIsTyping += txt;
                        }
                        this.userIsTyping = '*' + this.userIsTyping + '*';
                    } else {
                        txt = '';
                    }

                    // console.log('this.userIsTyping After --->', this.userIsTyping);

                    if (!this.loadMoreMessageFlag && !this.deletedMessageFlag && !this.reactMessageFlag)
                        setTimeout(() => {
                            this.scrollToBottom();
                        }, 500);

                    this.chatMessages.sort((a, b) => {
                        return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
                    });

                    if (this.chatMessages.length >= 25 && (this.messageLength != this.chatMessages.length)) {
                        this.showMoreMessages = true;
                    }
                    else {
                        this.showMoreMessages = false;
                    }

                    this.excludedUsers = '';

                    if (!this.loadMoreMessageFlag) {
                        this.threadUsers.map(user => {
                            this.chatMessages.map(message => {
                                if (message.sent_by != null) {
                                    if (message.sent_by.id == user.user.id) {
                                        message.sent_by.text_color_code = user.text_color_code;
                                        message.sent_by.bg_color_code = user.bg_color_code;
                                    };
                                }

                                if (Object.keys(message.reactions).length != 0) {
                                    Object.entries(message.reactions).forEach(
                                        ([key, value]) => {
                                            value.map(reactUser => {
                                                if (reactUser.user.id == user.user.id) {
                                                    reactUser.user.text_color_code = user.text_color_code;
                                                    reactUser.user.bg_color_code = user.bg_color_code;
                                                }
                                            })
                                        }
                                    );
                                }
                            });
                            if (user.user.id == this.current_user) {
                                this.isCurrentUserAdmin = user.is_admin ? true : false;
                                this.isCurrentUserOwner = user.is_owner ? true : false;
                            }

                            this.excludedUsers += user.user.id + ',';
                            this.threadUsers.sort(function (x, y) {
                                return (x.is_owner === y.is_owner) ? 0 : x.is_owner ? -1 : 1;
                            });
                        });
                    }

                    this.chatMessages = this.chatMessages.filter(item => item.thread == this.chat_thread);

                    this.lastActivity = this.chatMessages.length != 0 ? this.chatMessages[this.chatMessages.length - 1].created_at : null;

                    this.chatMessages.map(item => {
                        if (item.sent_by == null) {
                            item.message_mentions.map(mention => {
                                if (item.message.includes(mention.placeholder)) {
                                    item.message = item.message.replace(mention.placeholder,
                                        mention.placeholder.includes('edited_user') || mention.placeholder.includes('added_user') ||
                                            mention.placeholder.includes('removed_user') ?
                                            '**' + mention.user.first_name + ' ' + mention.user.last_name + '**' :
                                            mention.user.first_name + ' ' + mention.user.last_name);
                                }
                            });
                        } else {
                            if (item.message_mentions.length != 0) {
                                item.message_mentions.map(mention => {
                                    if (item.message.includes(mention.placeholder)) {
                                        item.message = item.message.replace(mention.placeholder, mention.user.first_name + ' ' + mention.user.last_name);
                                    }
                                });
                            }
                        }
                    });

                    if (this.insideChat) {
                        let threadUsersList = [];
                        let seenUsersList = [];
                        this.threadUsers.map(user => {
                            if (user.user.id != this.current_user)
                                threadUsersList.push(user.user.id);
                        });
                        this.chatMessages.map(item => {
                            if (item.sent_by != null) {
                                seenUsersList = [];
                                item.message_seen.map(user => {
                                    seenUsersList.push(user.user.id);
                                    if (threadUsersList.every(users => seenUsersList.includes(users))) {
                                        item.message_seen_flag = '0';
                                    } else if (threadUsersList.some(users => seenUsersList.includes(users))) {
                                        item.message_seen_flag = '1';
                                    }
                                });
                            }
                        });

                        // console.log('Updated chatMessages', this.chatMessages);
                    }

                    this.mentionFilteredData = this.threadUsers;

                    // console.log('this.allMessages: ', this.chatMessages);
                    this.reconnecting = false;
                    this.disconSocket = false;
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {
                    console.log('Socket Disconnected ...............');
                    this.disconSocket = true;
                    this.chatDisconnected = true;
                }
            });
    }

    ngAfterViewInit(): void {
        this.newChat = {
            type: 'latest_chat_message_list',
            data: {},
            context: {
                oldest_message_present: null,
                page_size: 25,
                thread: this.chat_thread,
            },
        };
        // console.log(this.newChat);
        this.chatService.wsSubject$.next(this.newChat);
        setTimeout(() => {
            this.setSelection();
        }, 1000);
        setTimeout(() => {
            if (this.chatMessages.length != 0) {
                this.newChat = {
                    type: 'message_seen',
                    data: {
                        message: this.chatMessages[this.chatMessages.length - 1].id
                    }
                };
                // console.log(this.newChat);
                this.chatService.wsSubject$.next(this.newChat);
            }
        }, 5000);

        interval(300000).subscribe(() => {
            this.newChat = {
                type: 'ping',
                context: {},
            };
            // console.log(this.newChat);
            this.chatService.wsSubject$.next(this.newChat);
            this.chatService.wsSubject$.subscribe(
                message => { },
                error => this.disconSocket = true,
                () => this.disconSocket = true
            );
        });

    }

    ngOnDestroy() {
        // console.log('Chat Closed............');
        this.insideChat = false;
    }
    backToList(){
        this.choosed ='chat';
        setTimeout(() => {
            this.back.emit();
        }, 1);
    }

    // sample() { was testing delete by 060623

    //     this.disconSocket = !this.disconSocket;
    // }
    // sample1() {
    //     this.reconnecting = !this.reconnecting;
    // }
    toggleAddUser() {
        this.addingUser = !this.addingUser;
        this.selectedUser = null;
    }

    toggleChatBox(set) {
        this.chatBoxMax = !set;
    }

    checkMessageType() {
        if (!this.mentionFlag) {
            this.sendMessage();
        }
    }

    enableDocLoad(a) {
        this.docLoading = a;
    }

    sendMessage() {
        this.chatService.resetDocumentTitle();
        this.mentionedUsers = [];

        if (this.uploadedFiles.length != 0) {
            this.isFileUploaded = true;
            // console.log("this.uploadedFiles", this.uploadedFiles);
            this.uploadedFiles.map(item => {
                this.selectedDocuments.push(item.id);
            })
        } else {
            this.isFileUploaded = false;
        }

        // this.message = this.message.replace(
        //     /(\b(?:https?|http|www|ftp):\/\/[^\s]+)/gi,
        //     '<a href="$&" target="_blank">$&</a>'
        // );

        if (this.isFileUploaded == false) {
            const msg = this.message.replace(/\s+/g, '');
            if (msg == "<p><br></p><p><br></p>" || msg == '<p></p><p><br></p>') {
                this._snackBar.open("Please type a message to continue!", 'Close', {
                    duration: 2000,
                });
                this.message = '';
                return false;
            }
        }

        this.message = this.message.replace(
            /(\b(?:https?|http|www|ftp):\/\/[^\s]+)/gi,
            '<a href="$&" target="_blank">$&</a>'
        );

        // console.log(this.message);
        this.threadUsers.map(user => {
            if (this.message.includes(user.user.first_name + ' ' + user.user.last_name)) {
                this.mentionedUsers.push({ user: user.user.id, placeholder: '::' + user.user.id + '::' });
            }
        });

        if (this.mentionedUsers.length != 0) {
            this.threadUsers.map(user => {
                // console.log(user);
                this.mentionedUsers.map(mentionedUser => {
                    if (mentionedUser.user == user.user.id) {
                        if (this.message.includes(user.user.first_name)) {
                            this.message = this.message.replace(user.user.first_name + ' ' + user.user.last_name, mentionedUser.placeholder);
                        }
                    }
                })
            })
        }

        this.newChat = {
            type: 'new_chat_message',
            data: {
                thread: this.chat_thread,
                message: this.message,
                replied_to: this.replyFlag ? this.chatId : null,
                documents: this.uploadedFiles.length != 0 ? this.selectedDocuments : [],
                mentions: this.mentionedUsers.length !== 0 ? this.mentionedUsers : []
            },
            context: {}
            // {
            //     oldest_message_present: this.chatMessages.length != 0 ? this.chatMessages[this.chatMessages.length - 1].id : null,
            //     page_size: 25,
            //     thread: this.chat_thread,
            // }
        };
        // console.log(this.newChat);
        this.chatService.wsSubject$.next(this.newChat);
        this.replyFlag = false;
        this.message = '';
        this.showEmojiPicker = false;
        this.scrollToBottom();
        this.selectedDocuments = null;
        this.uploadedFiles = [];
        this.mentionedUsers = [];
        // this.pastedText = [];
        this.threadUsers.map(user => {
            if (user.user.id == this.current_user)
                this.userIsTypingList.splice(this.userIsTypingList.indexOf(user.user.first_name + ' ' + user.user.last_name), 1);
        });

        this.newChat = {
            type: 'message_typing',
            data: {
                is_typing: false,
                thread: this.chat_thread
            }
        };
        // console.log(this.newChat);
        this.chatService.wsSubject$.next(this.newChat);
    }

    checkIfStringContainsOnlyHtmlTags(input: string): boolean {
        const htmlTagsRegex = /^<([a-z]+)([^<]+)*(?:>(.*)<\/\1>|\s+\/>)$/i;
        return htmlTagsRegex.test(input);
    }

    handleRetryError(delayTime) {
        let retries = 0;
        let exceedAttemptLimit = 5;
        return retryWhen((error) => {
            return error.pipe(
                tap((err) => {
                    console.error('Got error', err);
                    this.disconSocket = true;
                }),
                delay(delayTime),
                concatMap((err) => {
                    retries = retries + 1;
                    if (retries < exceedAttemptLimit) {
                        return of(err);
                    } else {
                        this.disconSocket = true;
                        throw err;
                    }
                })
            );
        });
    }

    toggleEmojiPicker() {
        this.showEmojiPicker = !this.showEmojiPicker;
    }

    addEmoji(event: any) {
        let { message } = this;
        message = message.replace(/<p>/g, '').replace(/<\/p>/g, '');
        // console.log(message);
        const text = message + ' ' + event.emoji.native;
        this.message = text;
        this.showEmojiPicker = false;
        // this.editor.quillEditor.focus();
        // this.chatterBox.focusInput();
        setTimeout(() => {
            this.setSelection();
        }, 1000);
    }

    setSelection() {
        const range: RangeStatic = {
            index: this.editor.quillEditor.getLength(),
            length: 0
        }
        this.editor.quillEditor.setSelection(range);
    }

    @HostListener('window:focus', ['$event'])
    onFocus() {
        this.showEmojiPicker = false;
    }

    @HostListener('window:blur', ['$event'])
    onBlur() {
        this.showEmojiPicker = false;
    }

    @HostListener('document:mousedown', ['$event'])
    onmousedown() {
        const concernedElement = document.querySelector(".emoji-click");
        const { target } = event;
        if (!(target instanceof Node && concernedElement.contains(target))) {
            this.showEmojiPicker = false;
        }
    }

    addReplyEmoji(event: any, id: string) {
        this.reactMessageFlag = true;

        const emoji = `${event.emoji.native}`;
        // this.message = text;
        // console.log(id, emoji);
        this.newChat = {
            type: 'react_message',
            data: {
                message: id,
                emoji: emoji,
            },
        };
        // console.log(this.newChat);
        this.chatService.wsSubject$.next(this.newChat);
    }

    showReply(chatId: string) {
        document.getElementById(chatId).style.display = 'flex';
    }

    hideReply(chatId: string) {
        document.getElementById(chatId).style.display = 'none';
    }

    scrollToBottom() {
        const element: HTMLElement = this.scrollContainer.nativeElement;
        setTimeout(() => {
            element.scrollTop = element.scrollHeight;
        }, 300);
        this.loadMoreMessageFlag = false;
        this.deletedMessageFlag = false;
        this.reactMessageFlag = false;
    }

    replyMessage(chatId: string, message: string, firstName: string, timing: string, documents: Documents[]) {
        this.chatId = chatId;
        this.replyToMessage = message;
        // console.log('documents ------->', documents);
        if (documents.length != 0) {
            documents.map(item => {
                message = message + ' ' + item.original_filename + '.' + item.extension;
            });
        }
        this.replyingto = message;
        this.replyingName = firstName;
        this.replyingToTiming = timing;
        this.replyFlag = true;
        document.getElementById('message').focus();
        // this.chatterBox.focusInput();
        const range: RangeStatic = {
            index: this.editor.quillEditor.getLength(),
            length: 0
        }
        this.editor.quillEditor.setSelection(range);
    }

    addUserInChat() {
        this.addingUser = !this.addingUser;
        this.userActions = {
            type: 'add_thread_user',
            data: {
                user: this.selectedUser.id,
                thread: this.chat_thread,
                is_admin: false
            }
        };
        // console.log(this.userActions);
        this.chatService.wsSubject$.next(this.userActions);
        this.selectedUser = null;
    }

    removeParticipant(user: ThreadUsers) {
        this.userActions = {
            type: 'remove_thread_user',
            data: {
                id: user.id,
            }
        };
        // console.log(this.userActions);
        this.chatService.wsSubject$.next(this.userActions);
    }

    leaveChat() {
        let id = '';
        this.threadUsers.map(user => {
            if (user.user.id == this.current_user)
                id = user.id
        });
        if (confirm('Are you sure you want to leave ?')) {
            this.userActions = {
                type: 'remove_thread_user',
                data: {
                    id: id,
                }
            };
            // console.log(this.userActions);
            this.chatService.wsSubject$.next(this.userActions);
        };
        this.chatService.noAccessToChat = true;
    }

    listParticipants() {
        this.userActions = {
            type: 'list_thread_user',
            context: {
                thread: this.chat_thread,
            }
        };
        // console.log(this.userActions);
        this.chatService.wsSubject$.next(this.userActions);
    }

    deleteChat(chat: Chats) {
        this.deletedMessageFlag = true;
        this.newChat = {
            type: 'delete_chat_message',
            data: {
                id: chat.id
            },
        };
        // console.log(this.newChat);
        this.chatService.wsSubject$.next(this.newChat);
        this.getSentDocuments();
    }

    loadLatestMessages(id: string) {
        this.newChat = {
            type: 'latest_chat_message_list',
            data: {},
            context: {
                oldest_message_present: id,
                page_size: 25,
                thread: this.chat_thread,
            },
        };
        // console.log(this.newChat);
        this.chatService.wsSubject$.next(this.newChat);
    }

    loadMoreMessages() {
        this.loadMoreMessageFlag = true;
        this.newChat = {
            type: 'latest_chat_message_list',
            data: {},
            context: {
                oldest_message_present: this.chatMessages[0].id,
                page_size: 25,
                thread: this.chat_thread,
            },
        };
        // console.log(this.newChat);
        this.chatService.wsSubject$.next(this.newChat);
    }

    addEditRoles(user: ThreadUsers, isAdmin: boolean) {
        this.userActions = {
            type: 'edit_thread_user',
            data: {
                id: user.id,
                thread: this.chat_thread,
                is_admin: isAdmin,
                user: user.user.id,
            }
        };
        // console.log(this.userActions);
        this.chatService.wsSubject$.next(this.userActions);
    }

    getFiles(a) {
        this.selectedDocuments = [];
        // console.log(a);
        if (a.length > 0) {
            this.displayFile = true;
            this.docLoading = false;
        }

        const range: RangeStatic = {
            index: this.editor.quillEditor != undefined ? this.editor.quillEditor.getLength() : 0,
            length: 0
        }
        this.editor.quillEditor != undefined ? this.editor.quillEditor.setSelection(range) : null;
        // this.chatterBox.focusInput();
        // this.editor.quillEditor.focus();
    }

    reconnectChat() {
        this.reconnecting = true;
        // this.chatService.wsSubject$.complete();
        this.chatMessages = [];
        this.chatService.initiateChat(this.authService.getToken());
        setTimeout(() => {
            // console.log(this.chatService.wsSubject$);
            this.chatService.wsSubject$.subscribe();
            this.newChat = {
                type: 'latest_chat_message_list',
                data: {},
                context: {
                    oldest_message_present: null,
                    page_size: 25,
                    thread: this.chat_thread,
                },
            };
            // console.log(this.newChat);
            this.chatService.wsSubject$.next(this.newChat);
            this.getMessages();
        }, 3000);
    }

    getSentDocuments() {
        this.sentDocumentsDetails = [];
        this.chatService.getSentDocuments(this.chat_thread, 1)
            .subscribe(res => {
                this.uploadedDocumentsCount = res.count;
                this.documentsNextPage = res.next;
                this.sentDocumentsDetails = res.results;
                this.sentDocumentsDetails.sort((a, b) => {
                    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
                });
            });
    }

    getNotifications() {
        this.newChat = {
            type: 'latest_message_notifications',
            data: {},
            context: {
                page_size: 10,
            },
        };
        // console.log(this.newChat);
        this.chatService.wsSubject$.next(this.newChat);
    }

    downloadDocument(documentFile: string) {
        // console.log(documentFile);
        window.open(documentFile, '_blank');
    }

    onKeyUp(event: any) {
        // this.mentionSearch = event.target.value != null ? event.target.value.substring(event.target.value.lastIndexOf('@'), event.target.length) : null;
        // console.log(event);
        const inputText = event.target.textContent;
        if (inputText.includes('@')) {
            // this.showSuggestions = true;
            this.mentionFlag = true;
        } else {
            // this.showSuggestions = false;
            this.mentionFlag = false;
        }

        // console.log(inputText);
        if (inputText != '') {
            // console.log(inputText.toString().length);
            if (inputText.toString().length == 1) {
                // console.log('is Typing true');
                this.newChat = {
                    type: 'message_typing',
                    data: {
                        is_typing: true,
                        thread: this.chat_thread
                    }
                };
                // console.log(this.newChat);
                this.chatService.wsSubject$.next(this.newChat);
            }
        }
        // else {
        //     this.newChat = {
        //         type: 'message_typing',
        //         data: {
        //             is_typing: false,
        //             thread: this.chat_thread
        //         }
        //     };
        //     // console.log(this.newChat);
        //     this.chatService.wsSubject$.next(this.newChat);
        // }
    }

    handleKeyDown(event: KeyboardEvent) {
        const isAltEnterRight = event.key === 'Enter' && event.keyCode == 18;
        const isAltEnterLeft = event.altKey && event.key === 'Enter';
        const shiftKeyLeft = event.shiftKey && event.key === 'Enter';

        if (isAltEnterRight || isAltEnterLeft || shiftKeyLeft) {
            event.preventDefault();

            const textArea = event.target as HTMLTextAreaElement;
            const caretPosition = textArea.selectionStart;

            const currentValue = textArea.value;
            const newValue = currentValue.substring(0, caretPosition) + '\n' + currentValue.substring(caretPosition);

            textArea.value = newValue;
            textArea.selectionStart = caretPosition + 1;
            textArea.selectionEnd = caretPosition + 1;
        }
    }

    checkAltAndShiftEnter(event) {
        if ((event.altKey || event.shiftKey) && event.key === 'Enter') {
            event.preventDefault();
            if (event.altKey) {
                if (this.editor) {
                    const quill = this.editor.quillEditor;
                    const selection = quill.getSelection(true);

                    const newLine = '\n';
                    quill.insertText(selection.index, newLine);
                    const range: RangeStatic = {
                        index: selection.index + newLine.length,
                        length: 0
                    }
                    quill.setSelection(range);
                }
            } else if (event.shiftKey) {
                if (this.editor) {
                    const quill = this.editor.quillEditor;
                    const newLine = '\n';
                    quill.deleteText(newLine.length, 0);
                }
            }
        } else if (event.key === 'Enter') {
            if (!this.mentionFlag)
                this.sendMessage();
        }
    }

    selectUser(user: ThreadUsers) {
        // console.log(this.mentionSearch);
        this.message = this.message.replace(this.mentionSearch, user.user.first_name + ' ' + user.user.last_name + ' ');
        this.showSuggestions = false;
        // this.chatterBox.focusInput();
        this.editor.quillEditor.focus();
        this.mentionFilteredData = this.mentionFilteredData.filter(item => item.user.id != user.user.id);
        this.mentionSearch = null;
        this.mentionedUsers.push({ user: user.user.id, placeholder: '::' + user.user.id + '::' });
        this.mentionFlag = false;
    }

    getRemovedMessages(event) {
        const inputElement = event.target as HTMLInputElement;
        const cursorStart = inputElement.selectionStart;
        const cursorEnd = inputElement.selectionEnd;

        if (cursorStart != cursorEnd) {
            this.deletedText = inputElement.value.slice(cursorStart, cursorEnd) + this.deletedText;
        } else if (cursorStart > 0) {
            this.deletedText = inputElement.value.slice(cursorStart - 1, cursorStart) + this.deletedText;
        } else {
            this.deletedText = '';
        }

        this.deletedText = this.deletedText.replace(/\s/g, "");
        // console.log('this.deletedText---------->', this.deletedText);

        if (this.deletedText != '') {
            this.threadUsers.map(user => {
                if (this.deletedText.trim().includes(user.user.first_name) || this.deletedText.trim().includes(user.user.last_name)) {
                    if (!this.mentionFilteredData.includes(user)) {
                        this.mentionFilteredData.push(user);
                        this.deletedText = '';
                    }
                }
            });
        }
    }

    checkTyping(event) {
        const inputText = event.target.textContent;
        if (inputText == '') {
            this.newChat = {
                type: 'message_typing',
                data: {
                    is_typing: false,
                    thread: this.chat_thread
                }
            };
            // console.log(this.newChat);
            this.chatService.wsSubject$.next(this.newChat);
        }
    }

    loadMoreDocuments() {
        this.chatService.getSentDocuments(this.chat_thread, +this.documentsNextPage.substring(this.documentsNextPage.length, this.documentsNextPage.length - 1))
            .subscribe(res => {
                this.uploadedDocumentsCount = res.count;
                this.documentsNextPage = res.next;
                if (res.results.length != 0) {
                    res.results.map(docs => {
                        this.sentDocumentsDetails.push(docs);
                    })
                }
                this.sentDocumentsDetails.sort((a, b) => {
                    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
                });
            });
    }

    checkForPS(message: string) {
        if (message.includes('<img')) {
            const imgRegex = /<img.*?src=['"](.*?)['"]/;
            const match = imgRegex.exec(message);
            if (match && match.length > 1) {
                const src = match[1];
                const win = window.open();
                win.document.write('<html><body><img src="' + src + '"></body></html>');
                win.document.close();
            }
        }
    }

    pastedText = [];

    savePrintScreen(e) {
        const items = (e.clipboardData || e.originalEvent.clipboardData).items;
        // console.log(items);
        let file = null;
        for (const item of items) {
            if (item.type.indexOf('image') === 0) {
                e.preventDefault();
                this.docLoading = true;
                file = item.getAsFile();
                let fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.');
                let fileExtension = file.name.split('.').pop();
                const document_obj = new FormData();
                document_obj.append('original_filename', fileNameWithoutExtension)
                document_obj.append('document_file', file)
                document_obj.append('extension', fileExtension.toLowerCase())
                document_obj.append('document_type', '94421bd4-ae33-4c61-9e7b-035cf72ddc11');
                this.docService.postChatDocument(document_obj).subscribe(res => {
                    this.uploadedFiles.push(res);
                    this.docLoading = false;
                });
                this.displayFile = true;
            } else {
                // const data = e.clipboardData?.getData('text/plain');
                // this.pastedText.push(data);
                // console.log(this.pastedText);
                // const regex = /^(http|https|www|ftp):\/\//i;
                // if (regex.test(this.pastedText)) {
                //     this.pastedText = '<u><a href="' + this.pastedText +  '" target="_blank">' + this.pastedText + ' ' + '</a></u>';                    
                //     return this.pastedText;
                // }
            }
        }
    }

    openLink(linkUrl: string) {
        window.open(linkUrl, '_blank');
    }

    openWarning(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2 }
        });
    }
}
